import { Fan } from "lucide-react";
import { AssetData } from "@/installation/installation";
import ThaloIcon from "@/assets/thalo_icon.svg";

const AnimatedFan = () => (
  <div className="rounded-full bg-gray-100 aspect-square grid grid-cols-1 h-full w-full">
    <Fan fill="#4B5563"
         className="z-10 h-full w-full text-gray-600 animate-spin animate-infinite col-span-full row-span-full"
         style={{ animationDuration: "2s" }}/>
    <div className="z-20 rounded-full bg-gray-300 aspect-square m-[20%] col-span-full row-span-full"></div>
  </div>
);

export const AssetWithFan = () => (
  <div className="flex flex-col items-center h-full w-full">
    <div
      className="relative bg-gray-200 rounded-md flex p-[6%] gap-[4%] items-center justify-center w-full grow"
    >
      <div className="grow h-full">
        <AnimatedFan/>
      </div>
      <div className="h-full flex flex-col gap-1 justify-start">
        <div className="h-1 w-1 bg-gray-400 rounded-lg"/>
        <div className="h-1 w-1 bg-gray-400 rounded-lg"/>
      </div>
    </div>
    <div className="flex justify-between w-1/2">
      <div className="h-1 w-2 bg-gray-400 rounded-b-md"/>
      <div className="h-1 w-2 bg-gray-400 rounded-b-md"/>
    </div>
  </div>
)

export const Capture = () => (
  <div
    className="relative h-full w-full p-[6%] flex flex-col items-center"
  >
    <div className="bg-gray-200 h-full w-3/4 rounded-md flex items-center justify-center">
      <img src={ThaloIcon} className="w-2/5"/>
    </div>
    <div className="flex justify-between w-[60%]">
      <div className="h-1 w-2 bg-gray-400 rounded-b-md"/>
      <div className="h-1 w-2 bg-gray-400 rounded-b-md"/>
    </div>
  </div>
)

export const AssetGlyph = ({ assetData }: { assetData: AssetData }) => {
  if (assetData.asset_type === "dac" || assetData.asset_type === "aq") {
    return <Capture/>
  }

  return <AssetWithFan/>
}
